import { getMenuList } from '@/api/login'
import {
  getTaskTemplateList,
  getRecentlyUpdate,
  getTemplate,
  GetTemplate,
  SiteDial,
  siteDial,
  wafTask,
  getArea,
  getProxy,
  deleteTemplate,
  DeleteTemplate,
  PostTemplate,
  postTemplate,
  PutTemplate,
  putTemplate,
  getAttackTypes,
  getTemplateDetail,
  GetTemplateDetail,
  getAttckList,
  getEnctype,
  getEncTypeList,
  GetSecurityDevice,
  getSecurityDevice,
  getTemplateList,
  GetTemplateList,
  getCaseList,
  GetCaseList,
  saveCaseToTemplate,
  SaveCaseToTemplate,
  getCaseDetail,
  GetCaseDetail,
  getAllTemplateId,
  getAllCaseId,
  getAttackTypeList,
  getResourceTagList,
  getResourceIdsByTemplateIds,
} from '@/api/waf-create-task'
import { getTaskGroups } from '@/api/account-center/task-management'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'

export const useTaskTemplateList = () => {
  const { data, runAsync: run } = useRequest(datas => getTaskTemplateList(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '模板资源列表获取失败')
    },
  })
  return [data?.data.items || [], run] as const
}

export const useRecentlyUpdate = () => {
  const { data, runAsync: run } = useRequest(datas => getRecentlyUpdate(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '最近更新获取数据失败')
    },
  })
  return [data?.data.items || [], run] as const
}

export const useGetTemplateDetail = () => {
  const { data, runAsync: run } = useRequest(
    (param: GetTemplateDetail) => getTemplateDetail(param),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || '模板详情获取失败')
      },
    },
  )
  return [data?.data || [], run] as const
}

// 获取模板分组
export const useGetTemplate = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((datas: GetTemplate) => getTemplate(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取分组列表失败')
    },
  })

  return [run, loading, data?.data || []] as const
}

export const useWafTask = () => {
  const { runAsync, loading } = useRequest(data => wafTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '创建任务失败')
    },
  })
  return [runAsync, loading] as const
}
// 网址认证
export const useSiteDial = () => {
  const { runAsync: run, loading } = useRequest((data: SiteDial) => siteDial(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '网址认证失败')
    },
  })
  return [run, loading] as const
}
export const useGetArea = () => {
  const { data, runAsync, loading } = useRequest(() => getArea(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全域失败')
    },
  })
  return [data?.data.items || [], runAsync, loading] as const
}

export const useGetAttckList = () => {
  const { data } = useRequest(() => getAttckList(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ATT&CK失败')
    },
  })
  return [data?.data?.items || []] as const
}

export const useGetProxy = () => {
  const { data, runAsync, loading } = useRequest(() => getProxy(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取代理池列表失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}
export const useDeleteTemplate = () => {
  const { runAsync, loading } = useRequest((data: DeleteTemplate) => deleteTemplate(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除自定义模板失败')
    },
  })
  return [runAsync, loading] as const
}
export const usePostTemplate = () => {
  const { runAsync, loading } = useRequest((data: PostTemplate) => postTemplate(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '新增自定义模板失败')
    },
  })
  return [runAsync, loading] as const
}
export const usePutTemplate = () => {
  const { runAsync, loading } = useRequest((data: PutTemplate) => putTemplate(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '新增自定义模板失败')
    },
  })
  return [runAsync, loading] as const
}

export const useGetAttackTypes = () => {
  const { data, runAsync, loading } = useRequest(() => getAttackTypes(), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || '获取攻击类型失败')
    },
  })
  return [data?.data.items || [], runAsync, loading] as const
}

export const useGetMenuList = () => {
  const { runAsync: run } = useRequest(getMenuList, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取权限列表失败')
    },
  })
  return [run] as const
}

export const useGetEncType = () => {
  const { data, runAsync: run } = useRequest(getEnctype, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取编码类型列表失败')
    },
  })
  return [data, run] as const
}

// 获取任务分组
export const useTaskGroup = () => {
  const { runAsync: run, data } = useRequest(params => getTaskGroups(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || '获取分组列表失败')
    },
  })

  return [data?.data?.groups || [], run] as const
}

// 获取编码类型列表
export const useGetEncTypeList = () => {
  const { data, runAsync } = useRequest(() => getEncTypeList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取编码类型列表失败')
    },
  })
  return [data?.data.list || [], runAsync] as const
}

// 获取关联安全设备
export const useGetSecurityDevice = () => {
  const { runAsync, data } = useRequest((params: GetSecurityDevice) => getSecurityDevice(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联安全设备失败')
    },
  })
  return [runAsync, data?.data?.siteDeviceList || []] as const
}

// 获取模板列表
export const useGetTemplateList = () => {
  const { runAsync, loading } = useRequest((params: GetTemplateList) => getTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取模板列表失败')
    },
  })
  return [runAsync, loading] as const
}

// 获取关联用例列表
export const useGetCaseList = () => {
  const { runAsync, loading } = useRequest((params: GetCaseList) => getCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联用例列表失败')
    },
  })
  return [runAsync, loading] as const
}

// 保存已选择用例为模板
export const useSaveCaseToTemplate = () => {
  const { runAsync, loading } = useRequest(
    (params: SaveCaseToTemplate) => saveCaseToTemplate(params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '保存模板失败')
      },
    },
  )
  return [runAsync, loading] as const
}

// 获取用例详情
export const useGetCaseDetail = () => {
  const { data, runAsync, loading } = useRequest((params: GetCaseDetail) => getCaseDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取用例详情失败')
    },
  })
  return [data?.data || {}, runAsync, loading] as const
}

// 获取所有模板id
export const useGetAllTemplateId = () => {
  const { data, runAsync } = useRequest((params: GetTemplateList) => getAllTemplateId(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取所有模板id失败')
    },
  })
  return [runAsync] as const
}

// 获取所有用例id
export const useGetAllCaseId = () => {
  const { data, runAsync } = useRequest((params: GetCaseList) => getAllCaseId(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取所有用例id失败')
    },
  })
  return [runAsync] as const
}

export const schedulerTypeMap = {
  scheduler_type_immediate: '即时任务',
  scheduler_type_reserve: '定时任务',
  scheduler_type_daily: '每天',
  scheduler_type_weekly: '每周',
  scheduler_type_monthly: '每月',
  scheduler_type_hourly: '每小时',
  scheduler_type_minutely: '每分钟',
}

// 获取攻击类型

export const useAttackTypeList = () => {
  const { data, runAsync } = useRequest(params => getAttackTypeList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取攻击类型失败')
    },
  })
  return [data?.data?.attackTypeFilters || [], runAsync] as const
}

// 获取用例标签

export const useResourceTagList = () => {
  const { data, runAsync } = useRequest(params => getResourceTagList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取用例标签失败')
    },
  })
  return [data?.data?.categoryList || [], runAsync] as const
}

// 根据templateIds获取resourceIds
export const useGetResourceIdsByTemplateIds = () => {
  const { data, runAsync } = useRequest(params => getResourceIdsByTemplateIds(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取资源id失败')
    },
  })
  return [data?.data?.resourceIds || [], runAsync] as const
}
